import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import { format } from "date-fns";
import { useEffect } from "react";
import { ROUTES } from "../routes";
import { CongfigurationOptionsCitiesAPI, useOrgCitiesListAPI } from "./api_hooks/org/useOrgCitiesListAPI";
import { usePWLFilters } from "./usePWLFilters";
import useRouteInfo from "./useRouteInfo";

type usePWLEffectOptions = {
  withCacheActions?: boolean;
};

export const usePWLEffect = (options?: usePWLEffectOptions) => {
  const currentDate = format(new Date(Date.now()), "yyyy-MM-dd");
  const routeId = ROUTES.ROOT.children.PATIENT_WAITING_LIST.id;
  const withCacheActions =
    (options && options?.withCacheActions && options?.withCacheActions === true ? true : false) || false;
  // API Hooks --------------------------------
  const { routeState } = useRouteInfo(routeId);
  const fetchOrgCities = useOrgCitiesListAPI("PATIENT_WAITING_LIST");
  const { getCachedPWLFilters } = usePWLFilters("GET");
  // API Hooks Ends  ----------------------------------

  const { clinics, cities } = routeState.state as IPatientWaitingListState;

  // Helper Functions --------------------------------
  // const getStaffCategoryId = (userRole: IUserRoleResponseData) => {
  //   return userRole?.staff_category[0]?.staff_category_id;
  // };
  useEffect(() => {
    let cityAPIConfig: CongfigurationOptionsCitiesAPI = {
      withClinics: true,
      clinicOptions: {},
      ROTADate: "",
      staffCategoryId: "",
      withClinicProviders: true,
    };
    const cachedFilters = getCachedPWLFilters();
    // Fetch Org Cities -> Org Clinics -> Org Providers
    if (clinics.length === 0 && cities.length === 0) {
      if (cachedFilters && withCacheActions) {
        // Filters in cache are set and the user role is not a doctor
        if (cachedFilters?.formDump?.city === "-1") {
          // all the cities are selected in the form dump
          cityAPIConfig = {
            ...cityAPIConfig,
            withClinics: true,

            ROTADate: cachedFilters?.date,
          };
        } else {
          cityAPIConfig = {
            ...cityAPIConfig,
            withClinics: true,
            ROTADate: cachedFilters?.date,
            clinicOptions: {
              cityId: cachedFilters.formDump.city,
            },
          };
        }
      } else {
        cityAPIConfig = {
          ...cityAPIConfig,
          withClinics: true,
          withMappedCity: true,
          ROTADate: currentDate,

          clinicOptions: {
            selectFirst: false,
            selectAll: false,
            withMappedClinic: true,
          },
        };
      }
      fetchOrgCities({ ...cityAPIConfig });
      // if (staffCategoryId === "7") {
      //   fetchOrgCities(true, cachedFilters?.date, staffCategoryId);
      // } else {

      // }
    }
  }, []);
};
